/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Scarica Bumble",
      "Accetta tutti",
      "Gestisci opzioni",
      "Normativa sui cookie",
      "Indietro",
      "Numero di telefono errato",
      "© {{current_year}} Bumble | Tutti i diritti sono riservati",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble",
      "Chi siamo",
      "Ambasciatori",
      "Blog",
      "Questo sito fa uso di cookie. Continuando, acconsenti al loro utilizzo.",
      "Scarica la App",
      "Scarica l'app per Android",
      "Scarica l'app per iOS",
      "Siamo spiacenti, ma la pagina che cerchi non è stata trovata.",
      "Accedi",
      "Invia",
      "Che fai, non vieni?",
      "Ops… qualcosa è andato storto"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "giorni"
            ],
            "singular": [
                  "giorno"
            ]
      },
      "hour": {
            "plural": [
                  "ore"
            ],
            "singular": [
                  "ora"
            ]
      },
      "minute": {
            "plural": [
                  "minuti"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mesi"
            ],
            "singular": [
                  "mese"
            ]
      },
      "second": {
            "plural": [
                  "secondi"
            ],
            "singular": [
                  "secondo"
            ]
      },
      "year": {
            "plural": [
                  "anni"
            ],
            "singular": [
                  "anno"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
